export default "dist/images/block-text-side-title-1.d314c39.png";